import { useState } from "react";

export default function FilterModal({ closeModal, applyFilter }) {
  const [activeType, setActiveType] = useState(1);
  const [gramAmount, setGramAmount] = useState(0);
  const [soatAmount, setSoatAmount] = useState(0);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  return (
    <div className="filter-modal-container">
      <div className="container x-visible-container wrapper-for-filter-container">
        <div className="row justify-content-center align-items-center">
          <div className="col-xl-6 col-md-8">
            <div className="filter-modal-header">
              <div className="filter-modal-header-content-wrapper">
                <div>فیلتر ها</div>
                <div onClick={closeModal}>
                  <img src={"/images/svg/arrow-left.svg"} alt={""} />
                </div>
              </div>
            </div>
            <div className="filter-sell-type">
              <div
                onClick={() => setActiveType(1)}
                className={
                  "buy-sell-filter-item" +
                  (activeType === 1 ? " active-buy-sell-filter" : "")
                }
              >
                خرید
              </div>

              <div
                onClick={() => setActiveType(2)}
                className={
                  "buy-sell-filter-item" +
                  (activeType === 2 ? " active-buy-sell-filter" : "")
                }
              >
                فروش
              </div>
            </div>
            <div className="label-for-filter">
              مقدار گرم یا سُوت را انتخاب کنید:
            </div>
            <div className="filter-amount-row">
              <div className="label-for-filter-right">گرم</div>
              <div className="amount-items">
                <div
                  className="inc-dec-amount-filter"
                  onClick={() =>
                    setGramAmount(gramAmount === 0 ? 0 : gramAmount - 1)
                  }
                >
                  -
                </div>
                <div className="filter-amount-number">
                  <input
                    type="number"
                    value={gramAmount}
                    onChange={(e) => setGramAmount(parseInt(e.target.value))}
                  />
                </div>
                <div
                  className="inc-dec-amount-filter"
                  onClick={() => setGramAmount(gramAmount + 1)}
                >
                  +
                </div>
              </div>
            </div>
            <div className="filter-amount-row">
              <div className="label-for-filter-right">سُوت</div>
              <div className="amount-items">
                <div
                  className="inc-dec-amount-filter"
                  onClick={() =>
                    setSoatAmount(soatAmount === 0 ? 0 : soatAmount - 1)
                  }
                >
                  -
                </div>
                <div className="filter-amount-number">
                  <input
                    type="number"
                    value={soatAmount}
                    onChange={(e) => setSoatAmount(parseInt(e.target.value))}
                  />
                </div>
                <div
                  className="inc-dec-amount-filter"
                  onClick={() => setSoatAmount(soatAmount + 1)}
                >
                  +
                </div>
              </div>
            </div>
            <div className="label-for-filter">محدوده قیمت را انتخاب کنید:</div>
            <div className="filter-row-price-range">
              <div className="label-from-price-range">از</div>
              <div className="price-input-filter">
                <input
                  type="number"
                  className="price-input-filter-number"
                  value={min}
                  onChange={(e) => setMin(e.target.value)}
                />
                <div className="small-note">
                  {min && !isNaN(min) && min > 0 && (
                    <div>
                      معادل {new Intl.NumberFormat("fa").format(min)} تومان
                    </div>
                  )}
                </div>
              </div>
              <div className="label-from-price-range"> تومان</div>
            </div>
            <div className="filter-row-price-range">
              <div className="label-from-price-range">تا</div>
              <div className="price-input-filter">
                <input
                  type="number"
                  onChange={(e) => setMax(e.target.value)}
                  value={max}
                  className="price-input-filter-number"
                />
                <div className="small-note">
                  {max && !isNaN(max) && max > 0 && (
                    <div>
                      معادل {new Intl.NumberFormat("fa").format(max)} تومان
                    </div>
                  )}
                </div>
              </div>
              <div className="label-from-price-range"> تومان</div>
            </div>
            <button
              className="action-bottom-sheet-button modal-action-btn"
              onClick={() =>
                applyFilter(activeType - 1, gramAmount + soatAmount / 1000, [
                  min,
                  max,
                ])
              }
            >
              اعمال فیلتر
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
